import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';

@Component({
  selector: 'app-celllinkrenderer',
  templateUrl: './celllinkrenderer.component.html',
  styleUrls: ['./celllinkrenderer.component.scss'],
  standalone: false
})
export class CelllinkrendererComponent {
  params: any = {};
  paramStore: any = {};

  hideLink: boolean = false;
  linkClass: string = 'btn btn-link';
  linkName: string = '';
  hoverText: string = '';
  public displayValue!: string;
  

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.displayValue = params.value;
    this.paramStore = params;

    //check for hoverText in params
    if ('hoverText' in params && typeof params.hoverText === 'function') {
      this.hoverText = params.hoverText(params);
    }
    // Check if linkClass has been set in params
    if ('linkClass' in params) {
      this.linkClass = params['linkClass'] as string;
    }
    // Check if linkName has been set in params
    if ('linkName' in params && typeof params.linkName === 'function') {
      this.linkName = params.linkName(params);
    }
    // Check for hideLink function
    if ('hideLink' in params && typeof params.hideLink === 'function') {
      this.hideLink = params.hideLink(params);
    }
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.paramStore = params;

    if ('hoverText' in params && typeof params.hoverText === 'function') {
      this.hoverText = params.hoverText(params);
    }
    // Check if linkClass has been set in params
    if ('linkClass' in params) {
      this.linkClass = params['linkClass'] as string;
    }
    // Check if linkName has been set in params
    if ('linkName' in params && typeof params.linkName === 'function') {
      this.linkName = params.linkName(params);
    }
    // Check for hideLink function
    if ('hideLink' in params && typeof params.hideLink === 'function') {
      this.hideLink = params.hideLink(params);
    }
    return true;
  }

  linkClick(params: any) {
    if (this.paramStore!.hasOwnProperty('callback')) {
      this.paramStore.callback(this.paramStore!.value, this.paramStore!.data!.authCode, this.paramStore!.data!.driversConsent);
    }
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }
}
